// 统一的港占星测试 API 模块 - 支持两种调用方式
// 1. 直接导入函数: import { getTeacherList, getForecastCategory } from '~/api/hkzxcs'
// 2. 导入 API 对象: import hkzxcsApi from '~/api/hkzxcs'; hkzxcsApi.getTeacherList()

// 创建统一的港占星测试 API 函数集合
const createHkzxcsApiMethods = () => {
	const { $axios } = useNuxtApp();

	// 通用请求方法
	const request = async config => {
		try {
			const response = await $axios(config);
			return response;
		} catch (error) {
			console.error("API请求错误:", error);
			throw error;
		}
	};

	return {
		// 获取老师推荐列表
		getTeacherList: params =>
			request({
				url: "/hkzxcs/productSite/get_teacher_list",
				method: "get",
				params,
			}),

		// 获取产品分类 (1：八字；2：运势；3：姻缘；4：其他)
		getForecastCategory: params =>
			request({
				url: "/hkzxcs/productSite/get_forecast_category",
				method: "get",
				params,
			}),

		// 获取用户订单
		getOrderList: params =>
			request({
				url: "/hkzxcs/productSite/get_user_order_list",
				method: "get",
				params,
			}),

		// 运势工具，通用资源位 (测试列表)
		getFortuneTools: params =>
			request({
				url: "/hkzxcs/productSite/get_tool_list",
				method: "get",
				params,
			}),

		// 首页数据
		getProductSite: params =>
			request({
				url: "/hkzxcs/productSite/index",
				method: "get",
				params,
			}),

		// 获取用户身份标识
		getUserIdent: () =>
			request({
				url: "/hkzxcs/point/user_ident",
				method: "get",
			}),

		trackEvent: params =>
			request({
				url: "/hkzxcs/point/pageevent",
				method: "post",
				data: params,
			}),

		// 获取地区信息（级联：初始 id=0，下级传当前选中 id）
		getAreaList: (params, config = {}) =>
			request({
				url: "/hkzxcs/area",
				method: "get",
				params,
				...config,
			}),
	};
};

// 懒加载港占星测试 API 实例
let hkzxcsApiInstance = null;
const getHkzxcsApiInstance = () => {
	if (!hkzxcsApiInstance) {
		hkzxcsApiInstance = createHkzxcsApiMethods();
	}
	return hkzxcsApiInstance;
};

// 导出单独的 API 函数（支持直接导入）
export const getTeacherList = params => getHkzxcsApiInstance().getTeacherList(params);
export const getForecastCategory = params => getHkzxcsApiInstance().getForecastCategory(params);
export const getOrderList = params => getHkzxcsApiInstance().getOrderList(params);
export const getFortuneTools = params => getHkzxcsApiInstance().getFortuneTools(params);
export const getProductSite = params => getHkzxcsApiInstance().getProductSite(params);
export const getUserIdent = () => getHkzxcsApiInstance().getUserIdent();
export const trackEvent = params => getHkzxcsApiInstance().trackEvent(params);
export const getAreaList = (params, config) => getHkzxcsApiInstance().getAreaList(params, config);
// 默认导出港占星测试 API 对象（支持 hkzxcsApi.方法名 调用）
const hkzxcsApi = {
	get: () => getHkzxcsApiInstance(),
};

// 使用 Proxy 来实现 hkzxcsApi.方法名 的调用方式
const hkzxcsApiProxy = new Proxy(hkzxcsApi, {
	get(target, prop) {
		if (prop === "get") {
			return target.get;
		}
		const instance = getHkzxcsApiInstance();
		if (prop in instance) {
			return instance[prop];
		}
		return undefined;
	},
});

export default hkzxcsApiProxy;
